import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";

export interface DrawingViewState {
	DrawingPath: string;
	Zoom: number;
	OffsetX: number;
	OffsetY: number;
}

export const getDrawingViewState = async (
	drawingPath: string,
): Promise<DrawingViewState | null> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "DrawingPath", value: drawingPath },
	];
	const resp = await apiService.callV2(
		"[FAB].[GetDrawingViewState]",
		parameters,
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows[0]", null) as DrawingViewState | null;
	}
	throw new Error(resp.message || "Error fetching drawing view state");
};

export const saveDrawingViewState = async (
	drawingPath: string,
	zoom: number,
	offsetX: number,
	offsetY: number,
) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "DrawingPath", value: drawingPath },
		{ name: "Zoom", value: Math.round(zoom) },
		{ name: "OffsetX", value: Math.round(offsetX) },
		{ name: "OffsetY", value: Math.round(offsetY) },
	];
	const resp = await apiService.callV2(
		"[FAB].[SaveDrawingViewState]",
		parameters,
	);

	if (resp.ok) {
		return resp;
	}
	throw new Error(resp.message || "Error saving drawing view state");
};
